import React from 'react'

const Contact = props => (
  <div className='col-12 mb-5'>
    <h2>Contact</h2>
    <p>
      Have a question? If you haven't found the answer to your question in <b><a href='/faq'>FAQ</a></b>, <br />
      feel free to shoot me an e-mail at: <b><a href="mailto:getreptapp@gmail.com" subject="Help with RePT">getreptapp@gmail.com</a></b>.
    </p>

    {props.children}
  </div>
)
export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js